<script setup lang="ts">
import { ref, computed, watch, getCurrentInstance } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  errorMessage: {
    type: String,
    default: '',
  },
  fullW: {
    type: Boolean,
    default: false,
  },
  settings: {
    type: Boolean,
    default: false,
  },
  inactiveLabel: {
    type: Boolean,
    default: false,
  },
  light: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const instanceId = getCurrentInstance()?.uid || Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000; // with fallback
const emit = defineEmits(["update:modelValue"]);
const inputValue = ref(props.modelValue);

watch(props, async () => {
  if (props.modelValue != inputValue.value) {
    inputValue.value = props.modelValue;
  }
});

const mainClasses = computed(() => {
  let classList = "";
  classList += props.errorMessage ? 'form-item--error ' : '';
  classList += props.fullW ? 'form-item--full-w ' : '';
  classList += props.settings ? 'form-item--toggle--settings ' : '';
  classList += props.light ? 'form-item--toggle--light ' : '';
  classList += props.inactiveLabel || props.disabled ? 'form-item--toggle--inactive-label ' : '';
  classList += props.disabled ? 'form-item--toggle--disabled ' : '';
  return classList;
});

function onChange() {
  emit("update:modelValue", inputValue.value);
};

</script>
<template>
  <div class="form-item form-item--toggle" :class="mainClasses">
    <div class="form-item--toggle__body">
      <label v-if="props.label" :for="inactiveLabel ? undefined : `toggle-${instanceId}`" class="form-item--toggle__label">
        {{ props.label }}
      </label>
      <input
        v-model="inputValue"
        @change="onChange"
        :id="`toggle-${instanceId}`"
        :disabled="disabled"
        type="checkbox">
      <label :for="`toggle-${instanceId}`" class="form-item--toggle__switch"></label>
    </div>
    <p v-if="props.description" class="form-item--toggle__description" >{{ props.description }}</p>
  </div>
</template>
